import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconIconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { modalCloseHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from '../ClosedFundsModalWithRouting/styles.css';

const modalDescription = `Closed funds are only allowed for direct rollovers. If indirect rollover is desired, the closed funds must be removed.`;

const ClosedFundsModal = () => {
  const { next } = useContext(FlowContext);

  const closeFundsModal = () => {
    return next('fonasuClosedFundsModal')();
  };
  return (
    <>
      <MFBeaconModal scale="mini" open removeCloseButton>
        <div className="beacon-modal__description">{modalDescription}</div>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            role="button"
            variant="tertiary"
            onClick={() => {
              modalCloseHandler();
              closeFundsModal();
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default ClosedFundsModal;
